import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

const COLUMNS = [
  ['S.No', (task, index) => index + 1],
  ['Task ID', (task) => task.task_id ?? task.Task_id ?? task.id ?? ''],
  ['Description', (task) => task.desp || task.Task_Name || task.task_description || ''],
  ['Client', (task) => task.customer_name || task.client_other || '-'],
  ['Project', (task) => task.project_name || task.project_other || '-'],
  ['Type', (task) => (Number(task.is_recurring) === 1
    ? 'Recurring'
    : (Number(task.Type_of_task) === 0 ? 'Daily' : 'One Time'))],
  ['Assignee', (task) => task.employee_name || task.assigned_to_name || task.employee_id || '-'],
  ['Assigned By', (task) => task.assigned_by_name || task.Assigned_by || '-'],
  ['Assigned Date', (task) => formatDate(task.create_date || task.assigned_date || task.timestamp)],
  ['Deadline', (task) => (Number(task.is_recurring) === 1 && task.recurring_from && task.recurring_to
    ? `${formatDate(task.recurring_from)} to ${formatDate(task.recurring_to)}`
    : formatDate(task.end_date || task.deadline || task.till_date))],
  ['Status', (task) => normalizeStatus(task)],
  ['Remarks', (task) => task.remarks || '-'],
];

function formatDate(value) {
  if (!value) return '-';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? String(value) : date.toLocaleDateString('en-GB');
}

function normalizeStatus(task) {
  const status = String(task.status || task.task_status || 'PENDING').toUpperCase().replace(/[_-]+/g, ' ').trim();
  if (['COMPLETED', 'COMPLETE', 'CLOSED'].includes(status)) return 'Completed';
  if (status === 'IN PROGRESS' || status === 'INPROGRESS') return 'In Progress';
  return 'Pending';
}

function buildRows(tasks) {
  return tasks.map((task, index) => {
    const row = {};
    COLUMNS.forEach(([label, accessor]) => { row[label] = accessor(task, index); });
    return row;
  });
}

function timestamp() {
  return new Date().toISOString().slice(0, 19).replace(/[:T]/g, '-');
}

export function exportTasksToExcel(tasks = [], { scope = 'Task Report' } = {}) {
  if (!tasks.length) {
    return { ok: false, message: 'There are no tasks to export.' };
  }
  const worksheet = XLSX.utils.json_to_sheet(buildRows(tasks));
  worksheet['!cols'] = COLUMNS.map(([label]) => ({ wch: label === 'Description' || label === 'Remarks' ? 40 : 16 }));
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Tasks');
  XLSX.writeFile(workbook, `${scope.replace(/\s+/g, '_')}_${timestamp()}.xlsx`);
  return { ok: true };
}

export function exportTasksToPDF(tasks = [], { scope = 'Task Report', summary = {} } = {}) {
  if (!tasks.length) {
    return { ok: false, message: 'There are no tasks to export.' };
  }
  const doc = new jsPDF({ orientation: 'landscape', unit: 'pt', format: 'a4' });

  doc.setFontSize(15);
  doc.text(scope, 40, 40);
  doc.setFontSize(9);
  doc.setTextColor(120);
  doc.text(`Generated ${new Date().toLocaleString('en-GB')}`, 40, 56);

  const summaryLine = Object.entries(summary)
    .map(([key, value]) => `${key}: ${value}`)
    .join('    ');
  if (summaryLine) {
    doc.text(summaryLine, 40, 70);
  }

  autoTable(doc, {
    startY: 82,
    head: [COLUMNS.map(([label]) => label)],
    body: buildRows(tasks).map((row) => COLUMNS.map(([label]) => String(row[label] ?? ''))),
    styles: { fontSize: 7.5, cellPadding: 3, overflow: 'linebreak' },
    headStyles: { fillColor: [49, 156, 22], halign: 'left' },
    columnStyles: { 2: { cellWidth: 150 }, 11: { cellWidth: 120 } },
    margin: { left: 40, right: 40 },
  });

  doc.save(`${scope.replace(/\s+/g, '_')}_${timestamp()}.pdf`);
  return { ok: true };
}
